import { getJson, putJson, deleteJson, withDone } from '@rad/utility/http';
export const getSavedProperties = getJson('/api/saved-properties');
export const getSavedPropertyIds = getJson('/api/saved-properties/ids');
export const saveProperty = (propertyId) => withDone(putJson(`/api/saved-properties/${propertyId}`))();
export const unsaveProperty = (propertyId) => withDone(deleteJson(`/api/saved-properties/${propertyId}`))();
